import { useState, useEffect } from 'react';

export default ({ app }) => {
	const [appGroup, setAppGroup] = useState(null);

	useEffect(() => {
		if (['posillico', 'materials', 'washplant'].includes(app))
			setAppGroup('pos');
		else if (['ppark', 'construx'].includes(app))
			setAppGroup('ppc');
		else
			setAppGroup(null);

	}, [app]);

	return appGroup;
};
